module.exports = __webpack_public_path__ + "img/features_img_question.f3d3854b.png";